var prefixUrl = function prefixUrl(url) {
  var defaultPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https';
  var prefix = "".concat(defaultPrefix, ":");

  if (!url) {
    return url;
  }

  if (url.startsWith('http')) {
    return url;
  }

  if (!url.startsWith('//')) {
    prefix = "".concat(prefix, "//");
  }

  return prefix + url;
};

export default prefixUrl;